import { Instagram, Music2, Youtube } from "lucide-react";

import { Avatar, AvatarFallback, AvatarImage } from "../../../components/ui/avatar";
import { cn } from "../lib/utils";
import type { MontageAccount } from "../lib/accounts";

const PLATFORM_LABEL: Record<MontageAccount["platform"], string> = {
  instagram: "Instagram",
  tiktok: "TikTok",
  youtube: "YouTube",
};

function PlatformIcon({ platform }: { platform: MontageAccount["platform"] }) {
  if (platform === "youtube") return <Youtube className="size-1/2" />;
  if (platform === "tiktok") return <Music2 className="size-1/2" />;
  return <Instagram className="size-1/2" />;
}

export function PublicAvatar({ account, className }: { account: MontageAccount; className?: string }) {
  return (
    <Avatar className={cn("size-8 shrink-0 border border-border bg-background", className)}>
      <AvatarImage src={account.avatarUrl} alt={account.name} />
      <AvatarFallback className="bg-muted text-muted-foreground">
        <PlatformIcon platform={account.platform} />
      </AvatarFallback>
    </Avatar>
  );
}

/** Заметная подпись назначения ролика в окне проверки. */
export function PublicAccountBanner({ account }: { account: MontageAccount }) {
  return (
    <div className="flex min-w-0 items-center gap-2.5 rounded-2xl border bg-muted/35 px-3 py-2.5">
      <PublicAvatar account={account} className="size-9" />
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="text-[11px] leading-tight text-muted-foreground">Паблик для публикации</span>
        <span className="truncate text-sm font-semibold">{account.name}</span>
      </span>
      <span className="shrink-0 rounded-full bg-background px-2 py-1 text-[11px] font-medium text-muted-foreground ring-1 ring-inset ring-border">
        {PLATFORM_LABEL[account.platform]}
      </span>
    </div>
  );
}
